<template>
	<ModalGenericModal
		:title="$t('clearFormPopupTitle')"
		container-class="max-w-sm clearFormPopupComponent"
		:click-outside-enabled="true"
		ref="baseModal">
		<div class="break-words pt-6 pb-3 px-6 relative z-30 text-popup-text bg-popup-bg border-x-2 border-popup-border">
			<p>{{ $t("clearFormPopupBody") }}</p>
		</div>

		<div class="flex justify-center gap-8 py-4 bg-popup-bg border-b-2 border-x-2 rounded-b-lg border-popup-border">
			<ButtonModalClose
				:label="$t('cancel')"
				@click="closeModal" />
			<ButtonModalAccept
				:label="$t('clearForm')"
				@click="confirmed" />
		</div>
	</ModalGenericModal>
</template>

<script setup>
	const emits = defineEmits(["confirmed"])
	const baseModal = ref(null)

	const openModal = () => baseModal.value?.openModal()
	const closeModal = () => baseModal.value?.closeModal()

	const confirmed = () => {
		closeModal()
		emits("confirmed")
	}

	defineExpose({
		openModal,
	})
</script>
